import { get, post } from '@/helpers/http'
import config from '@/helpers/config'
import utility from '@/helpers/utility'
import router from '@/router';

const getDefaultState = () => {
  return {
    selectingFilter: false,
    addingNotification: false,
    suggestions: [],
    suggestionsMeta: [],
    filtersSet: {},
    results: {},
    input: '',
    selectedId: false,
    selectedFilters: {},
    selectedView: false,
    selectedHash: false,
    gridItemHeight: 200,
    incomingUrl: '',
    searchToken: {},
    licensedDatasets: [],
    selectedChartTimeline: '',
    selectedDatasetControls: {
      'chart_type': 'ver_bar'
    },
    nextPage: {
      'datasets': 1,
      'pdfs': 1,
      'news': 1
    },
    meta: {
      'pdfs': {
        'paginator': {
          'current_page': 1,
          'per_page': 24,
          'last_page': 0,
          'from': 0,
          'to': 0,
          'total': 0
        },
        'parameters': {}
      },
      'datasets': {
        'paginator': {
          'current_page': 1,
          'per_page': 24,
          'last_page': 0,
          'from': 0,
          'to': 0,
          'total': 0
        },
        'parameters': {}
      },
      'news': {
        'paginator': {
          'current_page': 1,
          'per_page': 24,
          'last_page': 0,
          'from': 0,
          'to': 0,
          'total': 0
        },
        'parameters': {}
      },
      'datasetTopics': {
        'paginator': {
          'current_page': 1,
          'per_page': 24,
          'last_page': 0,
          'from': 0,
          'to': 0,
          'total': 0
        },
        'parameters': {}
      },
      'datasetProviders': {
        'paginator': {
          'current_page': 1,
          'per_page': 24,
          'last_page': 0,
          'from': 0,
          'to': 0,
          'total': 0
        },
        'parameters': {}
      },
      'pdfTopics': {
        'paginator': {
          'current_page': 1,
          'per_page': 24,
          'last_page': 0,
          'from': 0,
          'to': 0,
          'total': 0
        },
        'parameters': {}
      },
      'pdfProviders': {
        'paginator': {
          'current_page': 1,
          'per_page': 24,
          'last_page': 0,
          'from': 0,
          'to': 0,
          'total': 0
        },
        'parameters': {}
      }
    }
  }
}

const state = getDefaultState()

const getters = {
  getSelectingFilter (state) {
    return state.selectingFilter
  },
  getAddingNotification (state) {
    return state.addingNotification
  },
  getInput (state) {
    return state.input
  },
  getSearchToken (state) {
    return state.searchToken
  },
  getResults (state) {
    return state.results
  },
  getSuggestions (state) {
    return state.suggestions
  },
  getSelectedId (state) {
    return state.selectedId
  },
  getSelectedHash (state) {
    return state.selectedHash
  },
  getSelectedFilters (state) {
    let selectedFilters = {}

    for (const validFilter of config.validFilters) {
      if (state.selectedFilters[validFilter]) {
        selectedFilters[validFilter] = state.selectedFilters[validFilter]
      }
    }

    return selectedFilters
  },
  getSelectedDatasetControls (state) {
    return state.selectedDatasetControls
  },
  getSelectedChartTimeline (state) {
    return state.selectedChartTimeline
  },
  getGridItemHeight (state) {
    return state.gridItemHeight
  },
  getMeta (state) {
    return state.meta
  },
  getSelectedView (state) {
    return state.selectedView
  },
  parseQuery: (state, getters, rootState) => (initializing) => {
    let type = rootState.route.name.toLowerCase()
    let parsedFilters = {}
    let parsedControls = {}

    for (const filter of config.validFilters) {
      if (rootState.route.query[filter] !== undefined && rootState.route.query[filter].length > 0) {
        let rawValues = filter === 'queries' ? [rootState.route.query[filter]] : rootState.route.query[filter].split(',')
        let rawFilters = []

        for (const rawValue of rawValues) {
          let id = rawValue
          let name = rawValue
          let condition = false
          let conditionCheck = rawValue.split('~')

          if (conditionCheck.length > 1) {
            id = conditionCheck[1]
            name = conditionCheck[1]
            condition = conditionCheck[0]
          }

          let checkKey = utility.itemFound( { 'id': id, 'type': filter, 'attributes': { 'condition': condition } }, state.selectedFilters[filter])
          rawFilters.push({
            'id': id,
            'type': filter,
            'attributes': {
              'name': checkKey === false ? name : state.selectedFilters[filter][checkKey].attributes.name,
              'condition': checkKey === false ? condition : state.selectedFilters[filter][checkKey].attributes.condition,
              'initializing': checkKey === false ? true : false
            }
          })
        }

        Object.assign(parsedFilters, { [filter]: rawFilters })
      }
    }

    for (const control of config.validControls) {
      if (rootState.route.query[control] !== undefined && rootState.route.query[control].length > 0) {
        Object.assign(parsedControls, { [control]: rootState.route.query[control] })
      } else if (control !== 'display' || !rootState.app.appInitialized) {
        Object.assign(parsedControls, { [control]: rootState.app.defaultSettings[type][control] })
      }
    }

    if (!rootState.app.appInitialized) {
      rootState.app.appInitialized = true
    }

    return {
      'filters': parsedFilters,
      'controls': parsedControls
    }
  },
  getFiltersQuery: (state) => (view, method) => {
    let availableFilters = method === 'api' ? config.filterFields[view] : config.validFilters
    let baseFilters = ['topics', 'locations', 'trade_types', 'scales', 'providers']
    let queryParts = []

    if (method === 'api' && state.selectedFilters.queries && state.selectedFilters.queries.length > 0) {
      queryParts.push('queries=' + encodeURIComponent(state.selectedFilters.queries[0].id))
    }

    for (const validFilter of availableFilters) {
      let type = method === 'api' ? validFilter.key : validFilter

      if (state.selectedFilters[type] && state.selectedFilters[type].length > 0) {
        let filterParts = []

        for (const filter of state.selectedFilters[type]) {
          if (filter.attributes.condition !== false && ((baseFilters.includes(type) && filter.attributes.condition !== 'is') || (!baseFilters.includes(type) && filter.attributes.condition !== 'dc'))) {
            filterParts.push(filter.attributes.condition + '~' + encodeURIComponent(filter.id))
          } else {
            filterParts.push(encodeURIComponent(filter.id))
          }
        }

        queryParts.push(type + '=' + filterParts.join(','))
      }
    }

    return queryParts.length > 0 ? queryParts.join('&') + '&' : ''
  },
  getControlsQuery: (state, getters, rootState, rootGetters) => (view, method) => {
    let queryParts = []
    let settings = rootState.app.settings
    let defaultSettings = rootState.app.defaultSettings
    let defaultSort = rootGetters['app/getDefaultSort']
    //console.log(defaultSort)

    /*if (Object.keys(state.selectedFilters).length > 0) { // TODO: other checks too, almost works...
      defaultSettings[view].sort = 'relevance'
    } else {
      defaultSettings[view].sort = '-published'
    }*/

    if (method === 'token' || method === 'api' || (view !== 'search' && state.nextPage[view] !== 1)) {
      queryParts.push('page=' + state.nextPage[view])
    }

    if (method === 'token' || method === 'api' || settings[view].sort !== defaultSort) {
      if (settings[view].sort !== undefined) {
        queryParts.push('sort=' + settings[view].sort)
      }
    }

    if (method === 'token' || method === 'api' || settings[view].access !== defaultSettings[view].access) {
      queryParts.push('access=' + settings[view].access)
    }

    if (method !== 'token' && (method !== 'api' && settings[view].display !== defaultSettings[view].display)) {
      queryParts.push('display=' + settings[view].display)
    }

    if (view === 'news') {
      let direction = parseInt(state.nextPage[view]) > parseInt(state.meta[view].paginator.current_page) ? 'next' : 'prev'

      if (direction === 'next') {
        if (typeof state.meta[view].paginator.after_id === 'string' && state.meta[view].paginator.after_id.length > 0) {
          queryParts.push('after_id=' + state.meta[view].paginator.after_id)
        } else if (typeof settings[view].after_id === 'string' && settings[view].after_id.length > 0) {
          queryParts.push('after_id=' + settings[view].after_id)
        } /*else if (typeof settings[view].before_id === 'string' && settings[view].before_id.length > 0) {
          queryParts.push('before_id=' + settings[view].before_id)
        }*/
      } else {
        state.meta.news.paginator.current_page = 1
        /*if (typeof state.meta[view].paginator.before_id === 'string' && state.meta[view].paginator.before_id.length > 0) {
          queryParts.push('before_id=' + state.meta[view].paginator.before_id)
        } else if (typeof settings[view].before_id === 'string' && settings[view].before_id.length > 0) {
          queryParts.push('before_id=' + settings[view].before_id)
        } else if (typeof settings[view].after_id === 'string' && settings[view].after_id.length > 0) {
          queryParts.push('after_id=' + settings[view].after_id)
        }*/
      }
    }

    if (method === 'api') {
      queryParts.push('size=' + state.meta[view].paginator.per_page)
      queryParts.push('search_token=' + state.searchToken[view])
    }

    return queryParts.join('&')
  },
  getIncomingUrl (state) {
    return state.incomingUrl
  },
  getLicensedDatasets (state) {
    return state.licensedDatasets
  }
}

const actions = {
  resetState ({ commit }) {
    commit('RESET_STATE')
  },
  setInput ({ commit }, value) {
    commit('SET_INPUT', value)
  },
  setMeta ({ commit }, value) {
    commit('SET_META', value)
  },
  setResults ({ commit }, value) {
    commit('SET_RESULTS', value)
  },
  setSuggestions ({ commit }, value) {
    commit('SET_SUGGESTIONS', value)
  },
  setGridItemHeight ({ commit }, value) {
    commit('SET_GRID_ITEM_HEIGHT', value)
  },
  toggleDatasetControl ({ state, commit }, value) {
    let newDatasetControls = { ...state.selectedDatasetControls }

    if (value === 'ver_bar' || value === 'hor_bar' || value === 'stacked_ver_bar' || value === 'stacked_hor_bar' || value === 'ver_line' || value === 'hor_line' || value === 'pie' || value === 'datatable') {
      newDatasetControls.chart_type = value
    }

    commit('SET_SELECTED_DATASET_CONTROLS', newDatasetControls)
  },
  setSelectedId ({ commit }, value) {
    commit('SET_SELECTED_ID', value)
  },
  setSelectedHash ({ commit }, value) {
    commit('SET_SELECTED_HASH', value)
  },
  setSelectedChartTimeline ({ commit }, value) {
    commit('SET_SELECTED_CHART_TIMELINE', value)
  },
  setSelectedFilters ({ commit }, value) {
    if (value === false) {
      commit('SET_SELECTED_FILTERS', {})
    } else {
      commit('SET_SELECTED_FILTERS', value)
    }
  },
  setSelectedView ({ commit }, value) {
    commit('SET_SELECTED_VIEW', value)
  },
  setPageNumber ({ commit }, value) {
    commit('SET_PAGE_NUMBER', value)
  },
  async fetchSuggestions({ state, commit, getters }, url) {
    if (url !== false) {
      let response = await get(url)

      if (response) {
      //if (response && response.data.meta.parameters.search_token === state.searchToken[params.type]) {
        let results = {}
        let resultIds = []

        response.data.data.forEach(result => {
          let resultId = false

          if (result.type === 'topics') {
            resultId = 'TOPIC_' + result.id
          } else if (result.type === 'locations') {
            resultId = 'LOCATION_' + result.id
          } else if (result.type === 'trade_types') {
            resultId = 'TRADETYPE_' + result.id
          } else if (result.type === 'scales') {
            resultId = 'SCALE_' + result.id
          } else if (result.type === 'providers') {
            resultId = 'PROVIDER_' + result.id
          }

          results[resultId] = result
          resultIds.push(resultId)
        })

        let normalizedResults = {
          'byId': results,
          'allIds': resultIds
        }

        commit('SET_SUGGESTIONS', normalizedResults)
        commit('SET_SUGGESTIONS_META', response.data.meta)

        return true
      //}
      }
    }

    return false

    /*if (response) {
      let queriesSuggestion = { id: state.input, type: 'queries', attributes: { name: state.input, results: false, datasets: false, pdfs: false }}
      let fullSuggestions = response.data.data
      fullSuggestions.unshift(queriesSuggestion)
      commit('SET_SUGGESTIONS', fullSuggestions)

      return true
    }*/

    //return false
  },
  // TODO: REFACTOR THIS
  async fetchResults ({ state, commit, getters, rootState }, params) {
    let type = params.type ? params.type : params
    let view = params.view ? params.view : params
    let url = params.url ? params.url : type + '?' + getters.getFiltersQuery(view, 'api') + getters.getControlsQuery(view, 'api')

    if (url !== false) {
      await get(url, type).then(response => {
        if (response.data.meta && response.data.meta.parameters.search_token === state.searchToken[view]) { // TODO: Remove news check after API / NewsController.php has been refactored
          let results = {}
          let licensed = []
          let resultIds = []
          let initialFilterIds = []
          let initialFilters = {}

          response.data.data.forEach(result => {
            let resultId = false

            if (result.type === 'datasets') {
              resultId = 'DATASET_' + result.id

              results[resultId] = result
              if (result.attributes.licensed === true && result.attributes.providers[0].tag !== 'EM') {
                licensed.push(result.id)
              }

              let yearsWithValues = []
              let allYears = []
              let lowestValue = null

              for (let series in result.attributes.data_series) {
                for (let year in result.attributes.data_series[series]) {
                  let val = result.attributes.data_series[series][year]

                  if (val !== null) {
                    if (yearsWithValues.indexOf(year) === -1) {
                      yearsWithValues.push(year)
                    }
                    if (!lowestValue || val < lowestValue) {
                      lowestValue = val
                    }
                  }
                  if (allYears.indexOf(year) === -1) {
                    allYears.push(year)
                  }
                }
              }

              yearsWithValues.sort()
              allYears.sort()
              let firstValYear = yearsWithValues[0]
              let lastValYear = yearsWithValues[yearsWithValues.length -1]
              let startIndex = allYears.indexOf(firstValYear)
              let endIndex = allYears.indexOf(lastValYear)

              let newSeries = {}
              let decimals = -1

              if (lowestValue >= 1000) {
                decimals = 0
              } else if (lowestValue >= 100) {
                decimals = 1
              } else if (lowestValue >= 10) {
                decimals = 2
              } else if (lowestValue >= 1) {
                decimals = 3
              }

              for (let series in result.attributes.data_series) {
                newSeries[series] = {}
                let lastYear = false
                for (let i = startIndex; i <= endIndex; i++) {
                  let thisYear = parseInt(allYears[i])
                  if (lastYear === false) {
                    lastYear = parseInt(thisYear)
                  } else {
                    if (lastYear !== (parseInt(thisYear) - 1)) {
                      for (let i = (lastYear + 1); i < parseInt(thisYear); i++) {
                        newSeries[series][i] = null
                      }
                    }
                    lastYear = thisYear
                  }
                  if (!isNaN(result.attributes.data_series[series][allYears[i]])) {
                    newSeries[series][allYears[i]] = result.attributes.data_series[series][allYears[i]]
                  } else {
                    newSeries[series][allYears[i]] = null
                  }
                  if (decimals >= 0) {
                    newSeries[series][allYears[i]] = result.attributes.data_series[series][allYears[i]] ? parseFloat((result.attributes.data_series[series][allYears[i]]).toFixed(decimals)) : null
                  } else {
                    newSeries[series][allYears[i]] = result.attributes.data_series[series][allYears[i]]
                  }
                }
              }
              result.attributes.data_series = newSeries

              if (result.attributes.topics && result.attributes.topics[0] && result.attributes.topics[0].attributes && result.attributes.topics[0].attributes.name && result.attributes.topics[0].attributes.name.length > 0) {
                initialFilterIds.push('TOPIC_' + result.attributes.topics[0].id)
                initialFilters['TOPIC_' + result.attributes.topics[0].id] = result.attributes.topics[0]
              }
              if (result.attributes.locations && result.attributes.locations[0] && result.attributes.locations[0].attributes && result.attributes.locations[0].attributes.name && result.attributes.locations[0].attributes.name.length > 0) {
                initialFilterIds.push('LOCATION_' + result.attributes.locations[0].id)
                initialFilters['LOCATION_' + result.attributes.locations[0].id] = result.attributes.locations[0]
              }
              if (result.attributes.trade_types && result.attributes.trade_types[0] && result.attributes.trade_types[0].attributes && result.attributes.trade_types[0].attributes.name && result.attributes.trade_types[0].attributes.name.length > 0) {
                initialFilterIds.push('TRADETYPE_' + result.attributes.trade_types[0].id)
                initialFilters['TRADETYPE_' + result.attributes.trade_types[0].id] = result.attributes.trade_types[0]
              }
              if (result.attributes.scales && result.attributes.scales[0] && result.attributes.scales[0].attributes && result.attributes.scales[0].attributes.name && result.attributes.scales[0].attributes.name.length > 0) {
                initialFilterIds.push('SCALE_' + result.attributes.scales[0].id)
                initialFilters['SCALE_' + result.attributes.scales[0].id] = result.attributes.scales[0]
              }
              if (result.attributes.providers && result.attributes.providers[0] && result.attributes.providers[0].attributes && result.attributes.providers[0].attributes.name && result.attributes.providers[0].attributes.name.length > 0) {
                initialFilterIds.push('PROVIDER_' + result.attributes.providers[0].id)
                initialFilters['PROVIDER_' + result.attributes.providers[0].id] = result.attributes.providers[0]
              }
            } else if (result.type === 'pdfs') {
              resultId = 'PDF_' + result.id
              results[resultId] = result
            } else if (result.type === 'news') {
              resultId = 'NEWS_' + result.id
              results[resultId] = result
            }

            resultIds.push(resultId)
          })

          let normalizedResults = {
            'byId': results,
            'allIds': resultIds
          }

          let responseFilters = {}
          for (const validFilter of config.validFilters) {
            if (response.data.meta.parameters[validFilter] !== undefined && response.data.meta.parameters[validFilter].length > 0) {
              Object.assign(responseFilters, { [validFilter]: response.data.meta.parameters[validFilter] })
            }
          }

          let data = [ responseFilters, state.selectedFilters ]
          let mixed = []

          data.forEach(function iter(r) {
            return function (o) {
              let ref = r.find(p => o.id === p.id && o.type === p.type)

              if (!ref) {
                  r.push(o)
                  return
              }

              Object.keys(o).filter(k => Array.isArray(o[k])).forEach(k => o[k].forEach(iter(ref[k] = ref[k] || [])))
            }
          }(mixed))

          let resultFilters = mixed[0]

          let filterTypeArr = []
          let filterCount = 0
          
          Object.keys(resultFilters).forEach(function (filterType) {
            if (resultFilters[filterType].length > 0) {
              let filterArr = []
              
              resultFilters[filterType].forEach(function (filter) {
                let condition = filter.attributes.condition ? filter.attributes.condition : ''
                filterArr.push(condition + '~' + filter.attributes.name)
                filterCount++
                if (!params.preventGa && ((filterType === 'queries' && condition === 'dc') || (filterType === 'topics' && condition === 'is'))) {
                  utility.sendGoogleAnalyticsEvent(filterType + '_' + condition, filter.attributes.name, view, rootState.user.subscriptionStatus)
                }
              })
              
              filterTypeArr.push(filterType + ' = ' + filterArr.join(', '))
            }
          })
          
          let filterString = filterTypeArr.join(' | ')
          //utility.sendGoogleAnalyticsEvent('search_' + type, filterString, filterCount, rootState.user.isAuthenticated, rootState.user.subscriptionStatus)
          
          let newResults = state.results
          let newMeta = state.meta
          newResults[type] = normalizedResults
          newMeta[type] = response.data.meta

          // TODO: Don't fetch when searching "related data"
          //commit('SET_INITIAL_FILTER_RESULTS', normalizedFilterResults)
          commit('SET_RESULTS', newResults)
          commit('SET_META', newMeta)

          if (licensed.length > 0) {
            commit('SET_LICENSED_DATASETS', licensed)
          }

          // TODO: Set filters with another name when searching for companies/etc -> then we can use them when using "View all" buttons @ company/etc views!
          //if (name === false) {
            if (!['datasetTopics', 'datasetProviders', 'pdfTopics', 'pdfProviders'].includes(type)) {
              if (state.filtersSet[type] !== state.searchToken[type]) {
                commit('SET_SELECTED_FILTERS', resultFilters)
                commit('SET_FILTERS_SET', { 'type': type, 'token': state.searchToken[type] })
              }
            }
         // }

          /*if (response.data.meta.paginator.current_page === 1) {
            let clonedData = Object.assign({}, newResults)
            commit('SET_FIRST_RESULTS', clonedData)
          }*/

          return true
        } else if (type === 'datasetPdf') {
          let results = {}
          let resultIds = []

          if (response && response.data.data.id) {
            let result = response.data.data
            let resultId = 'PDF_' + result.id
            results[resultId] = result
            resultIds.push(resultId)

            let normalizedResults = {
              'byId': results,
              'allIds': resultIds
            }

            let newResults = state.results
            let newMeta = state.meta
            newResults[type] = normalizedResults

            commit('SET_RESULTS', newResults)
            commit('SET_META', newMeta)
          }
        }
      }).catch(error => {
        return Promise.reject(error)
      })
    }

    return false
  },
  async fetchDataset ({ state, commit, getters, rootState }, hash) {
    let url = 'datasets/' + hash
    let response = false
    try {
      response = await get(url)
    } catch (e) {
        router.push({ name: '404'})
        return false
    }

    if (response) {
      let result = response.data.data
      let resultId = 'DATASET_' + result.id
      let results = {}
      let licensed = []
      let resultIds = []

      results[resultId] = result
      if (result.attributes.licensed === true && result.attributes.providers[0].tag !== 'EM') {
        licensed.push(result.id)
      }
      let yearsWithValues = []
      let allYears = []
      let lowestValue = null
      for (let series in result.attributes.data_series) {
        for (let year in result.attributes.data_series[series]) {
          let val = result.attributes.data_series[series][year]
          if (val !== null) {
            if (yearsWithValues.indexOf(year) === -1) {
              yearsWithValues.push(year)
            }
            if (!lowestValue || val < lowestValue) {
              lowestValue = val
            }
          }
          if (allYears.indexOf(year) === -1) {
            allYears.push(year)
          }
        }
      }

      yearsWithValues.sort()
      allYears.sort()
      let firstValYear = yearsWithValues[0]
      let lastValYear = yearsWithValues[yearsWithValues.length -1]
      let startIndex = allYears.indexOf(firstValYear)
      let endIndex = allYears.indexOf(lastValYear)

      let newSeries = {}
      let decimals = -1

      if (lowestValue >= 1000) {
        decimals = 0
      } else if (lowestValue >= 100) {
        decimals = 1
      } else if (lowestValue >= 10) {
        decimals = 2
      } else if (lowestValue >= 1) {
        decimals = 3
      }

      for (let series in result.attributes.data_series) {
        newSeries[series] = {}
        let lastYear = false
        for (let i = startIndex; i <= endIndex; i++) {
          let thisYear = parseInt(allYears[i])
          if (lastYear === false) {
            lastYear = parseInt(thisYear)
          } else {
            if (lastYear !== (parseInt(thisYear) - 1)) {
              for (let i = (lastYear + 1); i < parseInt(thisYear); i++) {
                newSeries[series][i] = null
              }
            }
            lastYear = thisYear
          }
          if (!isNaN(result.attributes.data_series[series][allYears[i]])) {
            newSeries[series][allYears[i]] = result.attributes.data_series[series][allYears[i]]
          } else {
            newSeries[series][allYears[i]] = null
          }
          if (decimals >= 0) {
            newSeries[series][allYears[i]] = result.attributes.data_series[series][allYears[i]] ? parseFloat((result.attributes.data_series[series][allYears[i]]).toFixed(decimals)) : 0
          } else {
            newSeries[series][allYears[i]] = result.attributes.data_series[series][allYears[i]]
          }
        }
      }
      result.attributes.data_series = newSeries
      resultIds.push(resultId)

      let normalizedResults = state.results
      normalizedResults.dataset = {
        'byId': results,
        'allIds': resultIds
      }

      let normalizedMeta = state.meta
      normalizedMeta.dataset = response.data.meta

      //commit('SET_RESULTS', normalizedResults)
      //commit('SET_META', normalizedMeta)
      commit('SET_SELECTED_VIEW', 'dataset')
      commit('SET_SELECTED_HASH', resultId)
      commit('SET_SELECTED_ID', result.id)

      utility.sendGoogleAnalyticsEvent('document_datasets_open', result.attributes.title, 'url', rootState.user.subscriptionStatus)

      return true
    }

    return false
  },
  async fetchPDF ({ state, commit, getters, rootState }, hash) {
    let url = 'pdfs/' + hash
    let response = false
    try {
      response = await get(url)
    } catch (e) {
        router.push({ name: '404'})
        return false
    }

    if (response) {
      let result = response.data.data
      let resultId = 'PDF_' + result.id
      let results = {}
      let resultIds = []

      results[resultId] = result
      resultIds.push(resultId)

      let normalizedResults = state.results
      normalizedResults.pdf = {
        'byId': results,
        'allIds': resultIds
      }

      let normalizedMeta = state.meta
      normalizedMeta.pdf = response.data.meta

      //commit('SET_RESULTS', normalizedResults)
      //commit('SET_META', normalizedMeta)
      commit('SET_SELECTED_VIEW', 'pdf')
      commit('SET_SELECTED_HASH', resultId)
      commit('SET_SELECTED_ID', result.id)

      utility.sendGoogleAnalyticsEvent('document_pdfs_open', result.attributes.title, 'url', rootState.user.subscriptionStatus)

      return true
    }

    return false
  },
  logView ({ state, commit, getters }, hash) {
    let url = 'client/log'
    let data = { 'resource_hash': hash }
    post(url, data)

    return true
  },
  setIncomingUrl ({ commit }, value) {
    commit('SET_INCOMING_URL', value)
  },
  setSearchToken ({ state, commit, getters }, params) {
    let tokens = state.searchToken
    let setUrl = params.url !== false ? params.url : getters.getFiltersQuery(params.type, 'client') + getters.getControlsQuery(params.type, 'token')
    tokens[params.type] = utility.generateSearchToken(setUrl)

    commit('SET_SEARCH_TOKEN', tokens)
  },
  setSelectingFilter ({ commit }, value) {
    commit('SET_SELECTING_FILTER', value)
  },
  setAddingNotification ({ commit }, value) {
    commit('SET_ADDING_NOTIFICATION', value)
  }
}

const mutations = {
  RESET_STATE (state) {
    Object.assign(state, getDefaultState())
  },
  SET_INPUT (state, value) {
    state.input = value
  },
  SET_SEARCH_TOKEN (state, value) {
    state.searchToken = value
  },
  SET_RESULTS (state, value) {
    state.results = value
  },
  SET_SUGGESTIONS (state, value) {
    state.suggestions = value
  },
  SET_SUGGESTIONS_META (state, value) {
    state.suggestionsMeta = value
  },
  SET_SELECTED_ID (state, value) {
    state.selectedId = value
  },
  SET_SELECTED_HASH (state, value) {
    state.selectedHash = value
  },
  SET_SELECTED_FILTERS (state, value) {
    let formatted = {}

    for (let [key, val] of Object.entries(value)) {
      if (val[0]) {
        formatted[key] = val
      }
    }

    state.selectedFilters = formatted
  },
  SET_FILTERS_SET (state, obj) {
    state.filtersSet[obj.type] = obj.token
  },
  SET_SELECTED_DATASET_CONTROLS (state, value) {
    state.selectedDatasetControls = value
  },
  SET_GRID_ITEM_HEIGHT (state, value) {
    state.gridItemHeight = value
  },
  SET_META (state, value) {
    state.meta = value
  },
  SET_PAGE_NUMBER (state, params) {
    let type = params.type
    let value = params.value

    state.nextPage[type] = value
  },
  SET_SELECTED_VIEW (state, value) {
    state.selectedView = value
  },
  SET_SELECTED_CHART_TIMELINE (state, value) {
    state.selectedChartTimeline = value
  },
  SET_INCOMING_URL (state, value) {
    state.incomingUrl = value
  },
  SET_LICENSED_DATASETS (state, value) {
    state.licensedDatasets = value
  },
  SET_SELECTING_FILTER (state, value) {
    state.selectingFilter = value
  },
  SET_ADDING_NOTIFICATION (state, value) {
    state.addingNotification = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
